module.exports = {"headerTitle":"Contestações não respondidas","seeLess":"ver menos","seeAll":"ver todas","tableConfig":{"columns":[{"header":"DATA","width":"40%"},{"header":"VALOR (R$)","width":"60%"}]}}


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/ec/DashboardResume/contestations/data.json
// module id = 2233
// module chunks = 0